export type AppEnvironment = 'prod' | 'test';

export type AppContext = {
  app_name: string;
  app_version: string;
  app_environment: AppEnvironment;
};

export function buildAppContext({
  appName,
  productionHost,
  hostname,
  version,
}: {
  appName: string;
  productionHost: string;
  hostname: string;
  version?: string;
}): AppContext {
  return {
    app_name: appName,
    app_version: version?.trim() || 'unknown',
    app_environment: hostname === productionHost ? 'prod' : 'test',
  };
}
